import CustomerOpinions from './customerOpinions';

export default CustomerOpinions;
